import React, { useContext, useState, useEffect } from 'react';
import { useAssignRolesToUsersMutation, useGetUsersQuery } from '../../../services/SkillsManagement';
import { useDispatch } from 'react-redux';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import { Box,FormControl,InputLabel,Select,MenuItem, OutlinedInput, Chip, useTheme, Typography } from '@mui/material';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import LoaderSpinner from '../../../SystemDesign/LoaderSpinner';
import { tokens } from '../../../theme';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { ListItemIcon, ListItemText } from '@mui/material';
import MuiSelect from '../../../SystemDesign/MuiSelect';
import { LabelText, Text } from '../../../SystemDesign/Styles';
import { ASSIGN_ROLES_TO_USERS } from '../../../Reducers/Actions';
import { AuthContext } from '../../../Context/AuthContext';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const AssignRoleToUsers = ({ row }) => {
    const role = row.original;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [assignRolesToUsers] = useAssignRolesToUsersMutation();
    const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
    const [close, setClose] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const dispatch = useDispatch();
    const { user } = useContext(AuthContext);
    // Query to get all users
    const { data: usersData, isLoading } = useGetUsersQuery({
        type: 'user',
        filters:JSON.stringify({companyId:user.companyId}),
        pagination: "",
        sorting: ""
    });
   // Initialize selected users

   useEffect(() => {
    if (row.original.users && Array.isArray(row.original.users)) {
        const initialUsers = row.original.users.map(user => user.id);
        setSelectedUsers(initialUsers);
    }
}, [row,usersData]);

const handleUserChange = (event) => {
    const {
        target: { value },
    } = event;
    setSelectedUsers(typeof value === 'string' ? value.split(',') : value);
};

const handleSubmit = async () => {
    if (selectedUsers.length === 0) {
        setInfoAlert({ 
            severity: 'warning', 
            message: 'Please select at least one user' 
        });
        setOpenSnackBar(true);
        return;
    }

    try {
        const response =   await assignRolesToUsers({ 
            body: {
                userIds: selectedUsers,
                roleId: role.roleId
            }
        }).unwrap();
        dispatch({
            type: ASSIGN_ROLES_TO_USERS,
            payload: {
                roleId: role.roleId,
                users: response.users
            }
        });
        setInfoAlert({ 
            severity: 'success', 
            message: `Role assigned successfully to selected users` 
        });
        setOpenSnackBar(true);
        setClose(true);
        setSelectedUsers([]);
    } catch (error) {
        setInfoAlert({ 
            severity: 'error', 
            message: error.data?.message || 'An error occurred while assigning the role' 
        });
        setOpenSnackBar(true);
    }
};

// Transform users data for MuiSelect
const usersList = usersData?.users.map(user => ({

    id: user.id,
    name: `${user.username}`
})) || [];
return (
    <MuiDialog
        icon={<GroupAddIcon />}
        triggerButton={
            <MenuItem>
                <ListItemIcon>
                    <GroupAddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Assign to users</ListItemText>
            </MenuItem>
        }
        title="Assign role to users"
        subtitle={`Assign role to users ${role?.name}`}
        content={
            <Box sx={{ width: '100%', mt: 2 }}>
                <LoaderSpinner loading={isLoading} />
                <MuiSelect
                    list={usersList}
                    label="Users"
                    selectdValue={selectedUsers}
                    onChange={handleUserChange}
                    multiple={true}
                    required={true}
                    noneText="No users available"
                />
                {selectedUsers.length > 0 && (
                    <Box sx={{ mt: 2 }}>

                        <Typography sx={Text(colors)}>
                          Selected: {usersList.filter(user => selectedUsers.includes(user.id)).map(user => user.name).join(', ')}
                        </Typography>
                    </Box>
                )}
            </Box>
        }
        existAction={true}
        actionTitle="Assign"
        actionFunction={handleSubmit}
        onClose={close}
    />
);
};

export default AssignRoleToUsers;
